// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Libraries Imports
import StarRating from "reactjs-star-rating";
import { Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { Link } from "react-router-dom";

// Local Imports
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import CustomTable from "../../components/custom-table/custom-table";
import CustomSearch from "../../components/custom-search/custom-search";
import { Feedback } from "../../models/rating.model";
import { RatingService } from "./rating.service";
import moment from "moment";

const Rating: React.FC = (): ReactElement => {
  const ratingService: RatingService = new RatingService();
  const [ratingList, setRatingList] = useState<Feedback[]>([]);

  useEffect(() => {
    fetchRatingListData();
  }, []);

  const fetchRatingListData = async () => {
    const response = await ratingService.getRatingData();
    if (response) {
      setRatingList(response);
    }
  };

  const columns: ColumnsType<Feedback> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      sorter: (a: Feedback, b: Feedback) => a.id - b.id,
    },
    {
      title: "Customer ID",
      dataIndex: "accountCode",
      key: "accountCode",
      width: 140,
      sorter: (a: Feedback, b: Feedback) => a.accountCode - b.accountCode,
      fixed: "left",
      render: (text, record: Feedback) => (
        <Link to={`/home/business-account/${record.accountId}/details`}>{text}</Link>
      ),
    },
    {
      title: "OS",
      dataIndex: "operatingSytem",
      key: "operatingSytem",
      sorter: (a: Feedback, b: Feedback) =>
        a.operatingSytem.length - b.operatingSytem.length,
    },
    {
      title: "Phone model",
      dataIndex: "phoneModel",
      key: "phoneModel",
      width: 150,
      sorter: (a: Feedback, b: Feedback) =>
        a.phoneModel.length - b.phoneModel.length,
    },
    {
      title: "Rating value",
      dataIndex: "time",
      key: "time",
      width: 150,
      sorter: (a: Feedback, b: Feedback) => a.time - b.time,
      render: (text: number) => (
        <StarRating
          color="#002F6C"
          size={15}
          defaultRating={text}
          maxRating={5}
          showLabel={false}
          readOnly
        />
      ),
    },
    {
      title: "Notes",
      dataIndex: "feedbackDescription",
      key: "feedbackDescription",
      sorter: (a: Feedback, b: Feedback) =>
        a.feedbackDescription.length - b.feedbackDescription.length,
    },
    {
      title: "IP address",
      dataIndex: "ipAddress",
      key: "ipAddress",
      sorter: (a: Feedback, b: Feedback) =>
        a.ipAddress.length - b.ipAddress.length,
    },
    {
      title: "User agent",
      dataIndex: "userAgent",
      key: "userAgent",
      sorter: (a, b) => a.userAgent.length - b.userAgent.length,
    },
    {
      title: "Created at",
      dataIndex: "createdAt",
      width: 150,
      key: "createdAt",
      sorter: (a: Feedback, b: Feedback) =>
        a.createdAt.length - b.createdAt.length,
      render: (text: string) => (
        <span className=" text-gray-500">
          {moment(text).format("DD MMM, YYYY hh:mm A")}
        </span>
      ),
    },
  ];

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between flex-wrap">
        <BreadcrumbComponent />
      </div>
      <div>
        <div className=" flex items-center justify-between rounded-lg bg-white py-[10px] px-5">
          <p className=" text-black-300 text-base font-bold">
            {ratingList.length} User ratings
          </p>
          <div className="flex items-center">
            <CustomSearch />
            <Tooltip placement="topLeft" title="Columns settings">
              <img src={"/images/grid.svg"} alt="grid" />
            </Tooltip>
          </div>
        </div>
        <CustomTable columns={columns} data={ratingList} showPagination={false} />
      </div>
    </div>
  );
};

export default Rating;
